import React, { FC } from 'react';
// import { JsonLd } from 'next-seo/lib/jsonld/jsonld';
import { Heading, Text } from '@chakra-ui/react';
import Quiz from '../components/Quiz/Quiz';
import Page from '../components/Page';

const QuizPage: FC = () => (
  /* const assessmentJsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Assessment',
    name: 'Personalized Vitamin Requirement Quiz',
    description: 'The super quick and easy 6 question quiz will help us identify your daily Vitamin requirements.',
    url: 'https://vitaminclub.co.za/quiz/',
    publisher: {
      '@type': 'Organization',
      name: 'Vitamin Club',
      url: 'https://vitaminclub.co.za'
    },
    interactionStatistic: {
      '@type': 'InteractionCounter',
      interactionType: 'http://schema.org/CompleteAction',
      userInteractionCount: '144000' // TODO: Update numbers
    },
    potentialAction: {
      '@type': 'TakeAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://vitaminclub.co.za/quiz/'
      },
      result: {
        '@type': 'HealthAndBeautyBusiness',
        name: 'Vitamin Club'
      }
    }
  }; */

  <Page
    seoOptions={{
      title: 'A quick quiz to get you started on your Vitamin Club journey',
      description:
        'Discover Your Nutrient Needs with the Vitamin & Supplement Quiz. The super quick and easy 6 question quiz will ' +
        'help us identify your daily Vitamin requirements.',
      canonical: 'https://vitaminclub.co.za/quiz/',
      openGraph: {
        url: 'https://vitaminclub.co.za/quiz/',
        title: 'Personalized Vitamin Requirement Quiz - Vitamin Club',
        description:
          'Discover Your Nutrient Needs with the Vitamin & Supplement Quiz. The super quick and easy 6 ' +
          'question quiz will help us identify your daily Vitamin requirements.'
      }
    }}
  >
    {/* <JsonLd json={assessmentJsonLd} scriptKey='Assessment' /> */}
    <Heading as='h1' size='md' textAlign='center'>
      Discover Your Nutrient Needs: The Vitamin &amp; Supplement Quiz
    </Heading>

    <Quiz />

    <Heading as='h2' size='xs' mb={4}>
      Unlock Your Personalized Nutrition Plan with Our Vitamin Quiz
    </Heading>
    <Text mb={4}>
      Navigating the world of vitamins and supplements can be a complex journey. With our comprehensive and free Vitamin
      Quiz, you can demystify this process and tailor your daily intake to meet your health needs.
    </Text>

    <Text mb={4}>
      Whether you're curious about the benefits of Vitamin A, the right amount of Vitamin C and Zinc to take each day,
      or if you're seeking a personalized vitamin regimen, our quiz is designed to guide you. Our Vitamin Club Quiz
      evaluates your lifestyle, diet, and health goals to recommend the ideal supplement profile. Understanding why
      vitamins are essential is the first step towards optimal health.
    </Text>

    <Text mb={12}>Don't leave your health to guesswork; start your journey to a healthier you today!</Text>
  </Page>
);
export default QuizPage;
